/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Timeout from 'DesignSystem/Timeout/react'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Empty"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<Timeout
  viewPath={`${viewPath}/Timeout`}
 onTimeout={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Content'))}
/>
{children}
</React.Fragment>)
}